module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    attrs: {
      "id": "engineerBasicPackage"
    }
  }, [_c('div', {
    staticClass: "basicPackage container"
  }, [_c('span', {
    staticClass: "headerSpan",
    staticStyle: {
      "padding-bottom": "10px",
      "display": "block"
    }
  }, [_vm._v("背包类型")]), _vm._v(" "), _c('ul', {
    staticClass: "clearfix"
  }, [_vm._l((_vm.basicPackageLists), function(item, index) {
    return _c('li', {
      key: index,
      staticClass: "basicPackageListPart listPart",
      on: {
        "click": function($event) {
          return _vm.selectbasicPackage(item, index)
        }
      }
    }, [_vm._v("\n                  " + _vm._s(item.packName) + "\n                  "), _c('span', {
      class: {
        active: _vm.activeIndex === index
      }
    }, [_c('i', {
      staticClass: "el-icon-check"
    })]), _vm._v(" "), (_vm.basicsAuth.packTypeEdit) ? _c('span', {
      staticClass: "exitBtn",
      on: {
        "click": function($event) {
          $event.stopPropagation();
          return _vm.exitbasicPackage(item)
        }
      }
    }, [_vm._v("编辑")]) : _vm._e(), _vm._v(" "), (_vm.basicsAuth.delete_pack) ? _c('i', {
      staticClass: "el-icon-error activeDelBtn",
      on: {
        "click": function($event) {
          $event.stopPropagation();
          return _vm.deleteEngineerPack(item.id)
        }
      }
    }) : _vm._e()])
  }), _vm._v(" "), (_vm.basicsAuth.packTypeAdd) ? _c('li', {
    staticClass: "addContent",
    on: {
      "click": function($event) {
        return _vm.newbasicPackage()
      }
    }
  }, [_c('i', {
    staticClass: "el-icon-plus"
  })]) : _vm._e()], 2), _vm._v(" "), _c('el-dialog', {
    attrs: {
      "title": _vm.textMenu[_vm.dialogMenuStatus],
      "visible": _vm.dislogbasicPackage,
      "close-on-click-modal": false,
      "width": "600px"
    },
    on: {
      "update:visible": function($event) {
        _vm.dislogbasicPackage = $event
      },
      "close": function($event) {
        return _vm.emptyDialog('basicPackageForm')
      }
    }
  }, [_c('el-form', {
    ref: "basicPackageForm",
    attrs: {
      "model": _vm.basicPackageForm,
      "label-width": "120px",
      "label-position": _vm.labelPosition
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "基础包名称：",
      "prop": "packName"
    }
  }, [_c('el-input', {
    attrs: {
      "placeholder": "请输入基础包名称(不超过20个字)",
      "maxlength": "20"
    },
    model: {
      value: (_vm.basicPackageForm.packName),
      callback: function($$v) {
        _vm.$set(_vm.basicPackageForm, "packName", (typeof $$v === 'string' ? $$v.trim() : $$v))
      },
      expression: "basicPackageForm.packName"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "启用状态：",
      "prop": "status"
    }
  }, [_c('el-switch', {
    attrs: {
      "active-value": 1,
      "inactive-value": -1
    },
    model: {
      value: (_vm.basicPackageForm.status),
      callback: function($$v) {
        _vm.$set(_vm.basicPackageForm, "status", $$v)
      },
      expression: "basicPackageForm.status"
    }
  })], 1)], 1), _vm._v(" "), _c('span', {
    staticClass: "dialog-footer",
    attrs: {
      "slot": "footer"
    },
    slot: "footer"
  }, [(_vm.dialogMenuStatus !== 'update') ? _c('el-button', {
    attrs: {
      "type": "success"
    },
    on: {
      "click": function($event) {
        return _vm.addEventFormSubmitBtn('basicPackageForm')
      }
    }
  }, [_vm._v("添加")]) : _c('el-button', {
    attrs: {
      "type": "success"
    },
    on: {
      "click": function($event) {
        return _vm.saveEventFormSubmitBtn('basicPackageForm')
      }
    }
  }, [_vm._v("保存")]), _vm._v(" "), _c('el-button', {
    on: {
      "click": function($event) {
        return _vm.emptyDialog('basicPackageForm')
      }
    }
  }, [_vm._v("取 消")])], 1)], 1)], 1), _vm._v(" "), _c('el-row', {
    staticClass: "container-part2"
  }, [_c('el-col', [_c('span', {
    staticClass: "headerSpan"
  }, [_vm._v("品牌")]), _vm._v(" "), _c('ul', {
    staticClass: "clearfix",
    staticStyle: {
      "margin-bottom": "15px"
    }
  }, _vm._l((_vm.brandLists), function(item, index) {
    return _c('li', {
      key: index,
      staticClass: "fl listPart",
      class: {
        active: item.brandId === _vm.defaultBrandId
      },
      on: {
        "click": function($event) {
          return _vm.selectBrand(item, index)
        }
      }
    }, [_vm._v(_vm._s(item.brandName))])
  }), 0), _vm._v(" "), _c('span', {
    staticClass: "headerSpan"
  }, [_vm._v("品类")]), _vm._v(" "), _c('ul', {
    staticClass: "clearfix",
    staticStyle: {
      "margin-bottom": "15px"
    }
  }, _vm._l((_vm.categoryLists), function(item, index) {
    return _c('li', {
      key: index,
      staticClass: "fl listPart",
      class: {
        active: item.categoryId === _vm.defaultCategoryId
      },
      on: {
        "click": function($event) {
          return _vm.selectCategoryOpe(item, index)
        }
      }
    }, [_vm._v(_vm._s(item.categoryName))])
  }), 0), _vm._v(" "), _c('span', {
    staticClass: "headerSpan"
  }, [_vm._v("型号")]), _vm._v(" "), _c('ul', {
    staticClass: "clearfix",
    staticStyle: {
      "margin-bottom": "15px"
    }
  }, _vm._l((_vm.modelLists), function(item, index) {
    return _c('li', {
      key: index,
      staticClass: "fl listPart",
      class: {
        active: item.modelId === _vm.defaultModelId
      },
      on: {
        "change": function($event) {
          return _vm.changeModel()
        },
        "click": function($event) {
          return _vm.selectModelOpe(item, index)
        }
      }
    }, [_vm._v(_vm._s(item.modelName))])
  }), 0)])], 1), _vm._v(" "), _c('el-row', {
    staticClass: "container containerTable"
  }, [_c('p', [_vm._v("编辑基础物料")]), _vm._v(" "), (_vm.basicsAuth.packTypeEditByWs) ? _c('el-button', {
    staticStyle: {
      "margin": "10px 0"
    },
    attrs: {
      "size": "small",
      "type": "primary"
    },
    on: {
      "click": function($event) {
        return _vm.exitMater()
      }
    }
  }, [_vm._v(_vm._s(_vm.exitHtml))]) : _vm._e(), _vm._v(" "), (_vm.showText) ? _c('el-button', {
    attrs: {
      "type": "text"
    },
    on: {
      "click": function($event) {
        return _vm.newMater()
      }
    }
  }, [_vm._v("新增物料明细")]) : _vm._e(), _vm._v(" "), _c('el-table', {
    staticStyle: {
      "width": "800px"
    },
    attrs: {
      "data": _vm.returnData,
      "border": "",
      "header-cell-style": {
        'text-align': 'center'
      }
    }
  }, [_c('el-table-column', {
    attrs: {
      "align": "center",
      "prop": "materialCode",
      "min-width": "200",
      "label": "物料编号"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "align": "center",
      "prop": "materialName",
      "width": "200",
      "label": "物料名称"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "align": "center",
      "prop": "sum",
      "width": "250",
      "label": "基础包数量"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('el-input', {
          staticStyle: {
            "border-color": "transparent"
          },
          attrs: {
            "type": "number",
            "size": "small",
            "disabled": _vm.allowExit
          },
          model: {
            value: (scope.row.sum),
            callback: function($$v) {
              _vm.$set(scope.row, "sum", (typeof $$v === 'string' ? $$v.trim() : $$v))
            },
            expression: "scope.row.sum"
          }
        })]
      }
    }])
  }), _vm._v(" "), (_vm.exitStatus) ? _c('el-table-column', {
    attrs: {
      "align": "center",
      "label": "操作",
      "min-width": "50"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('el-button', {
          attrs: {
            "type": "text",
            "size": "small"
          },
          on: {
            "click": function($event) {
              $event.stopPropagation();
              return _vm.deleteRow(scope.$index, _vm.returnData)
            }
          }
        }, [_vm._v("移除")])]
      }
    }], null, false, 4207256149)
  }) : _vm._e()], 1), _vm._v(" "), _c('el-dialog', {
    attrs: {
      "title": "新增物料",
      "visible": _vm.dislogMater,
      "close-on-click-modal": false,
      "width": "700px"
    },
    on: {
      "update:visible": function($event) {
        _vm.dislogMater = $event
      }
    }
  }, [_c('el-table', {
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "data": _vm.newData,
      "border": "",
      "header-cell-style": {
        'text-align': 'center'
      }
    },
    on: {
      "selection-change": _vm.handleSelectionChange
    }
  }, [_c('el-table-column', {
    attrs: {
      "align": "center",
      "prop": "brandName",
      "label": "品牌"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "align": "center",
      "prop": "categoryName",
      "label": "品类"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "align": "center",
      "prop": "modelName",
      "label": "型号"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "align": "center",
      "prop": "materialCode",
      "label": "物料编号"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "align": "center",
      "prop": "materialName",
      "label": "物料名称"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "align": "center",
      "type": "selection",
      "width": "55"
    }
  })], 1), _vm._v(" "), _c('el-col', {
    staticClass: "toolbar",
    attrs: {
      "span": 24
    }
  }, [_c('div', {
    staticClass: "pagination"
  }, [_c('el-pagination', {
    attrs: {
      "background": "",
      "current-page": _vm.pages.page,
      "page-sizes": [10, 20, 50, 100],
      "page-size": _vm.pages.pageSize,
      "layout": "total, sizes, prev, pager, next,jumper",
      "total": _vm.pages.total
    },
    on: {
      "size-change": _vm.handleSizeChange,
      "current-change": _vm.handleCurrentChange
    }
  })], 1)]), _vm._v(" "), _c('span', {
    staticClass: "dialog-footer",
    attrs: {
      "slot": "footer"
    },
    slot: "footer"
  }, [_c('el-button', {
    attrs: {
      "type": "success"
    },
    on: {
      "click": function($event) {
        return _vm.addMaterSubmitBtn()
      }
    }
  }, [_vm._v("添加")]), _vm._v(" "), _c('el-button', {
    on: {
      "click": function($event) {
        return _vm.emptyNewData()
      }
    }
  }, [_vm._v("取 消")])], 1)], 1)], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// /opt/devenv/allscs-jhh/repair-ui/~/vue-loader/lib/template-compiler?{"id":"data-v-78227788","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!/opt/devenv/allscs-jhh/repair-ui/~/vue-loader/lib/selector.js?type=template&index=0!./src/views/basicSetting/engineerBasicPackage.vue
// module id = 1703
// module chunks = 0